import React from "react";
import { StepHeader } from "./components/StepHeader";
import { FullscreenModal } from "./components/FullscreenModal";
import { useSteps } from "./useSteps";
import { useWarehouseContext } from "./WarehouseProvider";
import escalationZoneIcon from "./assets/escalation-zone-icon.png";

const TITLE = "Reject - Storage Location";

export const RejectionConfirmation = () => {
  const { updateTakeback, clearTakeback, rejectCategory } =
    useWarehouseContext();
  const { exit } = useSteps();

  const onFinish = async () => {
    try {
      // Update takeback status and clear
      updateTakeback({
        isRejected: true,
        rejectStatus: "rejected",
        rejectCategory,
      });
      clearTakeback();
      exit({
        successMessage: "Package rejected and placed in escalation zone",
      });
    } catch (e) {
      console.error("Failed to process rejection:", e);
    }
  };

  const onViewGuidance = () => {
    window.open(
      "https://intercom.help/legobricktakeback/en/articles/8738741-how-to-process-hazardous-takebacks",
      "_blank"
    );
  };

  return (
    <FullscreenModal>
      <div className="flex flex-col h-full bg-[#030711]">
        <StepHeader />

        <div className="flex-1 flex flex-col items-center justify-center px-4">
          <div className="text-center max-w-2xl">
            {/* Escalation zone icon */}
            <img
              src={escalationZoneIcon}
              alt="Escalation zone"
              className="w-[168px] h-[168px] mx-auto mb-10"
            />

            <h1 className="text-[#E6ECFF] text-[29px] font-bold mb-2 leading-tight">
              Place in Escalation Zone
            </h1>

            <p className="text-[#C6CCE8] text-lg">
              Place material in escalation zone and contact support.
            </p>
          </div>
        </div>

        <div className="p-8 border-t border-[#282F44] backdrop-blur-lg">
          <div className="grid grid-cols-2 gap-8">
            <button
              className="rounded-xl font-medium border-2 border-[#282F44] bg-[#030711] text-[#E6ECFF] py-6 hover:bg-[#282F44]/20 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),inset_0px_-1px_1px_0px_rgba(0,0,0,0.16)] text-[21px] flex items-center justify-center gap-2"
              onClick={onViewGuidance}
            >
              View Guidance
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mt-0.5"
              >
                <path
                  d="M3.5 3.5V13.5H13.5V8.5H15V13.5C15 14.325 14.325 15 13.5 15H3.5C2.6675 15 2 14.325 2 13.5V3.5C2 2.675 2.6675 2 3.5 2H8.5V3.5H3.5ZM10.25 3.5V2H15V6.75H13.5V4.5575L7.2725 10.785L6.215 9.7275L12.4425 3.5H10.25Z"
                  fill="white"
                />
              </svg>
            </button>
            <button
              className="rounded-xl bg-[#173991] text-white hover:bg-[#1e4bb8] font-bold py-6 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),inset_0px_-1px_1px_0px_rgba(0,0,0,0.16)] text-[21px]"
              onClick={onFinish}
            >
              Ok, Done
            </button>
          </div>
        </div>
      </div>
    </FullscreenModal>
  );
};

RejectionConfirmation.title = TITLE;
